// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guest-wrapper {
    margin-top: 20px;
    width: 100%;
}

.guest-card {
    background-color: var(--bg-card);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-sm);
    border: 1px solid var(--border-light);
    overflow: hidden;
    transition: all 0.3s ease;
}

.guest-card.is-expanded {
    box-shadow: var(--shadow-card);
    border-color: var(--brand-primary);
}

.guest-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    cursor: pointer;
    background: transparent;
    transition: background-color 0.2s ease;
}

.guest-header:hover {
    background-color: var(--bg-app);
}

.header-content {
    display: flex;
    align-items: center;
    gap: 12px;
}

.icon-box {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(15, 23, 42, 0.05);
    color: var(--brand-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    transition: transform 0.2s ease;
}

.guest-card.is-expanded .icon-box {
    background-color: var(--brand-accent);
    color: var(--brand-accent-fg);
    transform: rotate(90deg);
}

.header-text h4 {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: var(--text-main);
}

.header-text p {
    margin: 2px 0 0 0;
    font-size: 0.85rem;
    color: var(--text-muted);
}

.chevron {
    color: var(--text-muted);
    transition: transform 0.3s ease;
}

.guest-card.is-expanded .chevron {
    transform: rotate(180deg);
}

.guest-body {
    padding: 0 20px 24px 20px;
    border-top: 1px solid transparent;
    animation: slideDown 0.3s ease-out;
}

.guest-card.is-expanded .guest-body {
    border-top-color: var(--border-light);
    padding-top: 20px;
}

@keyframes slideDown {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
}

.capacity-badge {
    padding: 10px 14px;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 500;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.capacity-badge.info {
    background-color: #EFF6FF;
    color: #1E40AF;
    border: 1px solid #DBEAFE;
}

.capacity-badge.waitlist {
    background-color: #FFFBEB;
    color: #92400E;
    border: 1px solid #FEF3C7;
}

.form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 16px;
}

@media (max-width: 500px) {
    .form-grid {
        grid-template-columns: 1fr;
    }
}

.form-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
}

.btn-add-guest {
    background-color: var(--brand-primary);
    color: white;
    padding: 12px 24px;
    border-radius: var(--radius-input);
    font-weight: 600;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    transition: var(--transition);
}

.btn-add-guest:hover {
    background-color: var(--text-main);
    transform: translateY(-1px);
}

.btn-add-guest:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.feedback-msg {
    padding: 10px;
    border-radius: 8px;
    margin-bottom: 15px;
    font-size: 0.9rem;
    text-align: center;
}
.feedback-msg.error { background: #FEF2F2; color: var(--error); }
.feedback-msg.success { background: #DCFCE7; color: #166534; }`, "",{"version":3,"sources":["webpack://./src/components/AmericanaGuestForm.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,4BAA4B;IAC5B,qCAAqC;IACrC,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,sCAAsC;AAC1C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;IACrC,6BAA6B;IAC7B,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,kCAAkC;AACtC;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,OAAO,UAAU,EAAE,4BAA4B,EAAE;IACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,qCAAqC;IACrC,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;AACA,sBAAsB,mBAAmB,EAAE,mBAAmB,EAAE;AAChE,wBAAwB,mBAAmB,EAAE,cAAc,EAAE","sourcesContent":[".guest-wrapper {\n    margin-top: 20px;\n    width: 100%;\n}\n\n.guest-card {\n    background-color: var(--bg-card);\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-sm);\n    border: 1px solid var(--border-light);\n    overflow: hidden;\n    transition: all 0.3s ease;\n}\n\n.guest-card.is-expanded {\n    box-shadow: var(--shadow-card);\n    border-color: var(--brand-primary);\n}\n\n.guest-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 20px;\n    cursor: pointer;\n    background: transparent;\n    transition: background-color 0.2s ease;\n}\n\n.guest-header:hover {\n    background-color: var(--bg-app);\n}\n\n.header-content {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.icon-box {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background-color: rgba(15, 23, 42, 0.05);\n    color: var(--brand-primary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.1rem;\n    transition: transform 0.2s ease;\n}\n\n.guest-card.is-expanded .icon-box {\n    background-color: var(--brand-accent);\n    color: var(--brand-accent-fg);\n    transform: rotate(90deg);\n}\n\n.header-text h4 {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 600;\n    color: var(--text-main);\n}\n\n.header-text p {\n    margin: 2px 0 0 0;\n    font-size: 0.85rem;\n    color: var(--text-muted);\n}\n\n.chevron {\n    color: var(--text-muted);\n    transition: transform 0.3s ease;\n}\n\n.guest-card.is-expanded .chevron {\n    transform: rotate(180deg);\n}\n\n.guest-body {\n    padding: 0 20px 24px 20px;\n    border-top: 1px solid transparent;\n    animation: slideDown 0.3s ease-out;\n}\n\n.guest-card.is-expanded .guest-body {\n    border-top-color: var(--border-light);\n    padding-top: 20px;\n}\n\n@keyframes slideDown {\n    from { opacity: 0; transform: translateY(-10px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n.capacity-badge {\n    padding: 10px 14px;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    margin-bottom: 20px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.capacity-badge.info {\n    background-color: #EFF6FF;\n    color: #1E40AF;\n    border: 1px solid #DBEAFE;\n}\n\n.capacity-badge.waitlist {\n    background-color: #FFFBEB;\n    color: #92400E;\n    border: 1px solid #FEF3C7;\n}\n\n.form-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n@media (max-width: 500px) {\n    .form-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n.form-actions {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 10px;\n}\n\n.btn-add-guest {\n    background-color: var(--brand-primary);\n    color: white;\n    padding: 12px 24px;\n    border-radius: var(--radius-input);\n    font-weight: 600;\n    border: none;\n    cursor: pointer;\n    box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n    transition: var(--transition);\n}\n\n.btn-add-guest:hover {\n    background-color: var(--text-main);\n    transform: translateY(-1px);\n}\n\n.btn-add-guest:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.feedback-msg {\n    padding: 10px;\n    border-radius: 8px;\n    margin-bottom: 15px;\n    font-size: 0.9rem;\n    text-align: center;\n}\n.feedback-msg.error { background: #FEF2F2; color: var(--error); }\n.feedback-msg.success { background: #DCFCE7; color: #166534; }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
